import React from "react";
import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import ViewListIcon from "@mui/icons-material/ViewList";
import TableChartIcon from "@mui/icons-material/TableChart";
import styled from "@emotion/styled";

export const RESULT_VIEW_LIST = "list";
export const RESULT_VIEW_TABLE = "table";

const ViewToggle = styled(ToggleButtonGroup)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#2A2A2A" : "#F3F3F4",
  borderRadius: 999,
  padding: 3,
  gap: 0,
  border: `1px solid ${
    theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(88, 89, 91, 0.14)"
  }`,
  transition: "box-shadow 160ms ease",
  "& .MuiToggleButtonGroup-grouped": {
    border: 0,
    borderRadius: "999px !important",
    margin: 0,
    minWidth: 36,
    height: 32,
    padding: "4px 10px",
    color: theme.palette.text.secondary,
    transition: "background-color 160ms ease, color 160ms ease, box-shadow 160ms ease",
  },
  "& .Mui-selected": {
    backgroundColor: `${theme.palette.mode === "dark" ? "#1E1E1E" : "#FFFFFF"} !important`,
    color: `${theme.palette.text.primary} !important`,
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 1px 4px rgba(0,0,0,0.35)"
        : "0 1px 4px rgba(23, 15, 74, 0.12)",
  },
  "& .MuiToggleButton-root:hover": {
    backgroundColor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
  },
}));

/**
 * Segmented List / Table control for Version 2 result presentation.
 * Icons match the existing CompanyList spreadsheet/list controls.
 */
export default function ResultViewToggle({ value, onChange, disabled = false }) {
  const handleChange = (_event, nextValue) => {
    if (nextValue != null) onChange(nextValue);
  };

  return (
    <ViewToggle
      exclusive
      size="small"
      value={value}
      onChange={handleChange}
      disabled={disabled}
      aria-label="Result view"
      data-testid="result-view-toggle"
    >
      <ToggleButton value={RESULT_VIEW_LIST} aria-label="List view" aria-pressed={value === RESULT_VIEW_LIST}>
        <Tooltip title="List view">
          <span style={{ display: "inline-flex" }}>
            <ViewListIcon sx={{ fontSize: 18 }} />
          </span>
        </Tooltip>
      </ToggleButton>
      <ToggleButton value={RESULT_VIEW_TABLE} aria-label="Table view" aria-pressed={value === RESULT_VIEW_TABLE}>
        <Tooltip title="Table view">
          <span style={{ display: "inline-flex" }}>
            <TableChartIcon sx={{ fontSize: 18 }} />
          </span>
        </Tooltip>
      </ToggleButton>
    </ViewToggle>
  );
}
